import { useSmartQuery } from "@shared/api/queries/hooks";
import { allAccountsApi } from "./api";

export const useConsumerConsumptionKpi = (params: {
  remote_utility_id: string | number;
  consumer_no: string;
  utility_service?: string;
}) => {
  return useSmartQuery(
    ["mx", "allAccounts", "consumerConsumptionKpi", params],
    () => allAccountsApi.getConsumerConsumptionKpi(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_no,
    }
  );
};

export const useConsumerMonthlyConsumption = (params: {
  remote_utility_id: string | number;
  consumer_no: string;
  no_of_months: string | number;
  utility_service?: string;
}) => {
  return useSmartQuery(
    ["mx", "allAccounts", "consumerMonthlyConsumption", params],
    () => allAccountsApi.getConsumerMonthlyConsumption(params),
    {
      enabled: !!params.remote_utility_id && !!params.consumer_no && !!params.no_of_months,
    }
  );
};
